import { gql } from "@apollo/client";

export const GET_PLATFORM_METRICS = gql`
  query GetPlatformMetrics {
    platformMetrics {
      companies {
        thisMonth
        lastMonth
        total
      }
      cards {
        thisMonth
        lastMonth
        total
      }
      funds {
        available
        incoming
        outgoing
        pastDue
        activeBalance
      }
      transactions {
        healthPercent
        completedTransactions
        totalTransactions
        averageSize
      }
    }
  }
`;

export const GET_MY_PLATFORM = gql`
  query myPlatform {
    myPlatform {
      id
      name
      defaultAppPlanIds
      defaultAddOnPlanIds
    }
  }
`;

export const GET_AVAILABLE_PLANS = gql`
  query availablePlans {
    availablePlans {
      appPlans {
        id
        name
        description
        appFeatureKeys
      }
      addOnPlans {
        id
        name
        description
        appFeatureKeys
      }
    }
  }
`;

export const GET_PLATFORM_CASH_FLOW = gql`
  query GetPlatformCashFlow {
    platformCashFlow {
      currency
      cashFlowData {
        date
        balance
      }
    }
  }
`;

export const GET_PLATFORM_TOP_CATEGORIES = gql`
  query GetPlatformTopCategories {
    platformTopCategories {
      name
      totalSpend
    }
  }
`;

export const GET_PLATFORM_TOP_COMPANIES = gql`
  query GetPlatformTopCompanies {
    platformTopCompanies {
      id
      name
      totalSpend
      changePercent
    }
  }
`;

export const GET_COMPANY_PLANS = gql`
  query companyPlans($companyId: ID!) {
    companyPlans(companyId: $companyId) {
      appPlanIds
      addOnPlanIds
    }
  }
`;

export const GET_PLATFORM_BRANDING = gql`
  query GetPlatformBranding {
    myPlatform {
      id
      name
      branding {
        keys {
          key
          name
          file {
            assetUrl
            filename
          }
        }
      }
    }
  }
`;

export const UPDATE_PLATFORM_BRANDING = gql`
  mutation UpdatePlatformBranding($input: PlatformBrandingInput!) {
    updatePlatformBranding(input: $input) {
      id
      branding {
        keys {
          key
          name
          file {
            assetUrl
            filename
          }
        }
      }
    }
  }
`;
